import React, { Component } from 'react';
import { NavItem, NavLink, Badge } from 'reactstrap';
import { CartContext } from '../../components/ParadigmaCartProvider/ParadigmaCartProvider';
import CartMenu from './CartMenu';
import PropTypes from 'prop-types';
import "./styles.scss";

class CartIconMenu extends Component {
    constructor(props) {
        super(props);
        this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
        this.state = {
            isCartMenuVisible: false,
            isMobile: window.matchMedia('(max-width: 768px)').matches
        };
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.mediaQueryList = window.matchMedia('(max-width: 768px)');
    }


    componentDidMount() {
		this.mediaQueryList.addEventListener('change', this.handleMediaQueryChange);
	}

	componentWillUnmount() {
		this.mediaQueryList.removeEventListener('change', this.handleMediaQueryChange);
	}

	handleMediaQueryChange(event) {
		this.setState({ isMobile: event.matches });
	}

    handleMouseEnter() {
        if (!this.context.isCartOpen) {
            this.setState({ isCartMenuVisible: true });
        }
    }

    handleMouseLeave() {
        this.setState({ isCartMenuVisible: false });
    }

    render() {
        const { isMobile } = this.state
        return (
            <CartContext.Consumer>
                {({ selectedItems, quantity, isCartOpen }) => (
                    <React.Fragment>
                        <div
                            className="header-login-menu"
                            onMouseEnter={this.handleMouseEnter}
                            onMouseLeave={this.handleMouseLeave}>
                            <NavItem>
                                <NavLink href={"#cart"}>
                                    <i style={{ fontSize: "30px" }} className="fa cui-cart c-white"></i>
                                    {selectedItems && selectedItems.length ? <Badge pill color="danger">{quantity()}</Badge> : null}
                                </NavLink>
                            </NavItem>
                            {this.state.isCartMenuVisible && !isCartOpen && !isMobile &&  <CartMenu />}
                        </div>
                    </React.Fragment>
                )}
            </CartContext.Consumer>
        );
    }
}

CartIconMenu.propTypes = {
    selectedItems: PropTypes.array,
    quantity: PropTypes.func,
};

export default CartIconMenu;



// WEBPACK FOOTER //
// ./src/views/Cart/CartIconMenu.js